/* ============================================================
   Razoryn theme JS — vanilla, no jQuery
   ============================================================ */

(function () {
  'use strict';

  window.theme = window.theme || {};
  window.theme.formatMoney = function (cents) {
    var amount = (cents / 100).toFixed(2);
    return '£' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  window.theme.routes = window.theme.routes || { root_url: '/', cart_url: '/cart' };

  /* ── Sticky header: shadow when scrolled, hide on scroll-down, show on scroll-up ── */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var lastY = 0;
    var ticking = false;
    var threshold = 8;
    var hideAfter = 200;
    var update = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > threshold);
      if (y > hideAfter) {
        if (y > lastY + 4) header.classList.add('is-hidden');
        else if (y < lastY - 4) header.classList.remove('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ── Mobile menu ──────────────────────────────────────── */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileMenu.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        mobileMenu.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Search modal ─────────────────────────────────────── */
  var searchToggle = document.querySelectorAll('[data-search-toggle]');
  var searchModal = document.querySelector('[data-search-modal]');
  if (searchToggle.length && searchModal) {
    var openSearch = function () {
      searchModal.classList.add('is-open');
      var input = searchModal.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 100);
      document.body.style.overflow = 'hidden';
    };
    var closeSearch = function () {
      searchModal.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    searchToggle.forEach(function (el) { el.addEventListener('click', openSearch); });
    searchModal.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchModal.classList.contains('is-open')) closeSearch();
    });
  }

  /* ── Quantity input ───────────────────────────────────── */
  document.querySelectorAll('[data-qty-input]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="number"]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    var max = parseInt(input.max, 10);
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > parseInt(input.min || 1, 10)) {
        input.value = v - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (!isNaN(max) && v >= max) return;
      input.value = v + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('input', function () {
      var v = parseInt(input.value, 10);
      if (!isNaN(max) && v > max) input.value = max;
    });
  });

  /* ── VAT toggle (Ex / Inc) ───────────────────────────── */
  var vatPref = function () {
    try { return localStorage.getItem('razoryn-vat') || 'inc'; } catch (e) { return 'inc'; }
  };
  var setVat = function (mode) {
    document.documentElement.setAttribute('data-vat', mode);
    try { localStorage.setItem('razoryn-vat', mode); } catch (e) {}
    document.querySelectorAll('[data-vat-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.vatToggle === mode ? 'true' : 'false');
    });
  };
  setVat(vatPref());
  document.querySelectorAll('[data-vat-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { setVat(btn.dataset.vatToggle); });
  });

  /* ── Dark / Light mode toggle ────────────────────────── */
  var themePref = function () {
    try { return localStorage.getItem('razoryn-theme') || 'light'; } catch (e) { return 'light'; }
  };
  var setTheme = function (mode) {
    document.documentElement.setAttribute('data-theme', mode);
    try { localStorage.setItem('razoryn-theme', mode); } catch (e) {}
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.themeToggle === mode ? 'true' : 'false');
    });
  };
  setTheme(themePref());
  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { setTheme(btn.dataset.themeToggle); });
  });

  /* ── Dispatch countdown ───────────────────────────────── */
  document.querySelectorAll('[data-dispatch-countdown]').forEach(function (el) {
    var cutoffH = parseInt(el.dataset.cutoffHour || '12', 10);
    var cutoffM = parseInt(el.dataset.cutoffMinute || '0', 10);
    var skipWeekends = el.dataset.weekendsOff !== 'false';
    var label = el.querySelector('[data-countdown-text]');
    var update = function () {
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(cutoffH, cutoffM, 0, 0);
      var day = now.getDay();
      var weekend = day === 0 || day === 6;
      if (now > cutoff || weekend) {
        var next = new Date(cutoff);
        do { next.setDate(next.getDate() + 1); }
        while (skipWeekends && (next.getDay() === 0 || next.getDay() === 6));
        if (label) label.textContent = 'Next dispatch: ' + next.toLocaleDateString('en-GB', { weekday: 'long' });
      } else {
        var diff = cutoff - now;
        var hours = Math.floor(diff / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        if (label) {
          var t = hours > 0 ? hours + 'h ' + mins + 'm' : mins + 'm';
          label.innerHTML = 'Order in <strong>' + t + '</strong> for same-day dispatch';
        }
      }
    };
    update();
    setInterval(update, 30000);
  });

  /* ── Tabs ─────────────────────────────────────────────── */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = group.querySelectorAll('[data-tab-trigger]');
    var panels = group.querySelectorAll('[data-tab-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var name = t.dataset.tabTrigger;
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        panels.forEach(function (p) {
          if (p.dataset.tabPanel === name) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
      });
    });
  });

  /* ── Predictive search ────────────────────────────────── */
  var searchInput = document.querySelector('[data-predictive-input]');
  var searchResults = document.querySelector('[data-predictive-results]');
  if (searchInput && searchResults) {
    var debounce;
    searchInput.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; searchResults.classList.remove('is-open'); return; }
      debounce = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var content = doc.querySelector('[data-predictive-content]');
            searchResults.innerHTML = content ? content.innerHTML : '';
            searchResults.classList.add('is-open');
          })
          .catch(function () {});
      }, 250);
    });
    document.addEventListener('click', function (e) {
      if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
        searchResults.classList.remove('is-open');
      }
    });
  }

  /* ── Cart count ───────────────────────────────────────── */
  window.theme.updateCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  };

  /* ── Vehicle/collection grid filter (shop-by-vehicle search) ── */
  document.querySelectorAll('[data-vehicle-filter]').forEach(function (input) {
    var grid = document.querySelector('[data-vehicle-grid]');
    if (!grid) return;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      grid.querySelectorAll('[data-vehicle-item]').forEach(function (item) {
        var label = (item.dataset.vehicleLabel || '').toLowerCase();
        item.style.display = (q === '' || label.indexOf(q) !== -1) ? '' : 'none';
      });
    });
  });

  /* ── Price match modal ────────────────────────────────── */
  document.querySelectorAll('[data-price-match-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var m = document.querySelector('[data-price-match-modal]');
      if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    });
  });
  document.querySelectorAll('[data-price-match-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var m = document.querySelector('[data-price-match-modal]');
      if (m) { m.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
  });
})();
